<template>
  <div>
    <div
      style="font-family: 'NanumBarunGothic'"
      class="winbox-list-place-enabled"
    >
      <!-- 검색바 등 -->
      <div class="winbox-selected-place-top text-center">
        <div style="margin-top: 8px">
          <span>
            <b-form-select
              class="text-center"
              style="
                margin-top: -10px;
                text-decoration: underline;
                border-color: transparent;
                color: white;
                background-color: transparent;
                width: 240px;
                height: 50px;
                font-size: 25px;
              "
              v-model="selectedAirport"
              :options="airportOption"
            ></b-form-select>
          </span>
          <span style="color: white; font-size: 20px"> 의</span>
          <span>
            <b-form-select
              class="text-center"
              style="
                margin-top: -10px;
                text-decoration: underline;
                border-color: transparent;
                color: white;
                background-color: transparent;
                width: 120px;
                height: 50px;
                font-size: 25px;
                margin-left: 20px;
              "
              v-model="selectedYear"
              :options="yearOption"
            ></b-form-select>
          </span>
          <span style="color: white; font-size: 20px"> 년도 소음통계자료</span>
        </div>
      </div>
      <!-- 왼쪽 -->
      <div class="winbox-selected-place-left" v-if="isWinboxLeft">
        <!--isWinboxLeft t/f-->
        <div class="winbox-selected-place-title noselect">
          <p class="title">
            <strong>{{ wbtitle }} / {{ wbarp }}-{{ wbno }} </strong>
          </p>
          <p class="sub">{{ wbaddr }}</p>
        </div>
        <div class="winbox-selected-place-map noselect">
          <div id="map" class="leaflet-container"></div>
        </div>
        <div class="winbox-selected-place-detail noselect">
          <p v-if="selectedYear>=2023" class="winbox-selected-place-detail-month">
            <strong>측정국 월별 소음 정보(LdendB)</strong>
          </p>
          <p v-else class="winbox-selected-place-detail-month">
            <strong>측정국 월별 소음 정보(WECPNL)</strong>
          </p>
          <div>
            <div
              style="margin-left: -15px; margin-top: -5px; margin-right: 3px"
              id="chart"
            >
              <apexchart
                ref="apexChart"
                height="200px"
                width="100%"
                :options="chartOptions"
                :series="noiseSeries"
              ></apexchart>
            </div>
          </div>
                  <div style="margin-top: -15px">
          <table
            style="width: 100%; margin-top: -5px; border: 1px solid whitesmoke"
          >
            <thead
              class="text-center"
              style="font-size: 12px; border: 1px solid whitesmoke"
            >
              <tr v-if="selectedYear>=2023">
                <th>기준년월</th>
                <th>LdendB</th>
              </tr>
              <tr v-else>
                <th>기준년월</th>
                <th>WECPNL</th>
              </tr>
            </thead>
            <tbody class="text-center" style="font-size: 12px">
              <tr v-if="selectedStatistics[0]">
                <td>1월</td>
                <td>{{ selectedStatistics[0] }}</td>
              </tr>
              <tr v-if="selectedStatistics[1]">
                <td>2월</td>
                <td>{{ selectedStatistics[1] }}</td>
              </tr>
              <tr v-if="selectedStatistics[2]">
                <td>3월</td>
                <td>{{ selectedStatistics[2] }}</td>
              </tr>
              <tr v-if="selectedStatistics[3]">
                <td>4월</td>
                <td>{{ selectedStatistics[3] }}</td>
              </tr>
              <tr v-if="selectedStatistics[4]">
                <td>5월</td>
                <td>{{ selectedStatistics[4] }}</td>
              </tr>
              <tr v-if="selectedStatistics[5]">
                <td>6월</td>
                <td>{{ selectedStatistics[5] }}</td>
              </tr>
              <tr v-if="selectedStatistics[6]">
                <td>7월</td>
                <td>{{ selectedStatistics[6] }}</td>
              </tr>
              <tr v-if="selectedStatistics[7]">
                <td>8월</td>
                <td>{{ selectedStatistics[7] }}</td>
              </tr>
              <tr v-if="selectedStatistics[8]">
                <td>9월</td>
                <td>{{ selectedStatistics[8] }}</td>
              </tr>
              <tr v-if="selectedStatistics[9]">
                <td>10월</td>
                <td>{{ selectedStatistics[9] }}</td>
              </tr>
              <tr v-if="selectedStatistics[10]">
                <td>11월</td>
                <td>{{ selectedStatistics[10]}}</td>
              </tr>
              <tr v-if="selectedStatistics[11]">
                <td>12월</td>
                <td>{{ selectedStatistics[11] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        </div>
      </div>
      <div class="winbox-selected-place-left" v-else style="text-align: center">
        <img
          src="../img/icons/kac.png"
          alt=""
          style="margin-top: 70%; width: 80px"
        />
      </div>
      <div class="winbox-selected-place-list">
        <div style="margin-top: 20px">
          <table
            style="
              width: 98%;
              margin-left: 1%;
              margin-top: -5px;
              border: 1px solid whitesmoke;
              color: whitesmoke;
            "
          >
            <thead
              class="text-center"
              style="font-size: 16px; border: 1px solid whitesmoke"
            >
              <tr>
                <th>측정국</th>
                <th>1월</th>
                <th>2월</th>
                <th>3월</th>
                <th>4월</th>
                <th>5월</th>
                <th>6월</th>
                <th>7월</th>
                <th>8월</th>
                <th>9월</th>
                <th>10월</th>
                <th>11월</th>
                <th>12월</th>
              </tr>
            </thead>
            <tbody
              class="text-center"
              style="font-size: 16px"
              v-for="(i, j) in noiseSensorPoint.FeatureCollection.featureMember"
              :key="j"
            >
              <tr
                class="trow_list"
                v-if="
                  noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.ARP_SE ===
                  selectedAirport
                "
                @click="selectlistEntity(noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001)"
              >
                <td>
                  
                  {{ noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM }}
                </td>
                <td
                  v-if="
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ]
                  "
                >
                  {{
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ][0]
                  }}
                </td>
                <td
                  v-if="
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ]
                  "
                >
                  {{
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ][1]
                  }}
                </td>
                <td
                  v-if="
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ]
                  "
                >
                  {{
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ][2]
                  }}
                </td>
                <td
                  v-if="
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ]
                  "
                >
                  {{
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ][3]
                  }}
                </td>
                <td
                  v-if="
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ]
                  "
                >
                  {{
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ][4]
                  }}
                </td>
                <td
                  v-if="
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ]
                  "
                >
                  {{
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ][5]
                  }}
                </td>
                <td
                  v-if="
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ]
                  "
                >
                  {{
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ][6]
                  }}
                </td>
                <td
                  v-if="
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ]
                  "
                >
                  {{
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ][7]
                  }}
                </td>
                <td
                  v-if="
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ]
                  "
                >
                  {{
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ][8]
                  }}
                </td>
                <td
                  v-if="
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ]
                  "
                >
                  {{
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ][9]
                  }}
                </td>
                <td
                  v-if="
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ]
                  "
                >
                  {{
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ][10]
                  }}
                </td>
                <td
                  v-if="
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ]
                  "
                >
                  {{
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ][11]
                  }}
                </td>
                <td
                  v-if="
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ]
                  "
                >
                  {{
                    statistics[
                      noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                    ][12]
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { url } from "../config/url"
import { mode } from "../config/mode.js"

import axios from "axios"
import { BFormSelect } from "bootstrap-vue"
import "leaflet/dist/leaflet.css"
import * as mapConfig from "..//config/map.js"

export default {
  props: ["noiseSensorPoint"],
  data() {
    return {
      time: null,
      localTime: null,
      selectedYear: null,
      yearOption: [],
      airportOption: [
        { value: "GMP", text: "김포국제공항" },
        { value: "CJU", text: "제주국제공항" },
        { value: "PUS", text: "김해국제공항" },
        { value: "ICN", text: "인천국제공항" },
      ],
      selectedAirport: "GMP",
      monthIndex: [
        "month1",
        "month2",
        "month3",
        "month4",
        "month5",
        "month6",
        "month7",
        "month8",
        "month9",
        "month10",
        "month11",
        "month12",
      ],
      leafletInstance: null,
      statistics: {},
      selectedStatistics:{}, 
      miniMapOptions: mapConfig.defaultMiniMapOptions,
      isWinboxLeft: false,
      wbtitle: null,
      wbarp: null,
      wbno: null,
      wbaddr: null,
      wbgeo: null,
      //Map Layers
      tileLayers: mapConfig.tileLayers,
      //Others
      viewMap: false,
      viewInf: false,
      viewApt: false,
      //Chart
      noiseSeries: [
        {
          name: "db(A)",
          data: [],
        }
      ],

      chartOptions: {
        legend: {
          show : false,
        },
        chart: {
          toolbar: {
            show: false,
          },
          height: 350,
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
          borderColor: "white",
          strokeDashArray: 0,
          position: "back",
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        stroke: {
          curve: "smooth",
        },
        tooltip: {
          enabled: false,
        },
        yaxis: {
          labels: {
            style: {
              colors: [
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
              ],
            },
          },
          tooltip: {
            enabled: false,
            offsetX: 0,
          },
        },
        xaxis: {
          type: "category",
          categories: [
            "1월",
            "2월",
            "3월",
            "4월",
            "5월",
            "6월",
            "7월",
            "8월",
            "9월",
            "10월",
            "11월",
            "12월",
          ],
          tickPlacement: "on",
          max: 12,
          labels: {
            style: {
              colors: [
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
              ],
            },
          },
        },
      },
    }
  },
  methods: {
    selectlistEntity: function (entity) {
      let info = null
      let inum = null
      this.isWinboxLeft = true
      this.wbtitle = entity.NMS_NM
      this.wbarp = entity.ARP_SE
      this.wbno = entity.NMT_NO
      this.wbaddr = entity.MARK_ADDR
      let latlng = entity.GEOM.Point.pos.split(' ')
      let lat = latlng[1]
      let lng = latlng[0]

      this.wbgeo = {
        lat : lat, 
        lng : lng 
      }
      info = this.wbarp
      inum = this.wbno
      setTimeout(() => {
        this.loadMiniMap(this.wbgeo)
        let trigger = false
        if (this.statistics !== {}) {
          for (let i in this.statistics) {
            if (i === entity.NMS_NM) {
              trigger = true
              this.selectedStatistics = this.statistics[i]
              this.noiseSeries[0].data = JSON.parse(JSON.stringify(this.statistics[i]))
              for (let j in this.noiseSeries[0].data){
                if(this.noiseSeries[0].data[j]==='')this.noiseSeries[0].data[j] = null
              }
              console.log(this.statistics[i])
              this.$refs.apexChart.updateSeries(
                this.noiseSeries,
                false,
                true
              )
            }
          }
          if (!trigger) {
            this.noiseSeries[0].data = []

            this.$refs.apexChart.updateSeries(
              this.noiseSeries,
              false,
              true
            )
          }
        }
      }, 200)
    },
    loadMiniMap: function (_this) {
      if (this.leafletInstance !== null) {
        this.leafletInstance.remove()
      }
      this.leafletInstance = L.map("map", this.miniMapOptions).setView(_this)
      let tileLayer = L.tileLayer.wms(
       url[mode.where].satMapServerLeaflet
      )
      tileLayer.addTo(this.leafletInstance)
    },

    getStatistic: function () {
      this.statistics = {}
      axios
        .get(
          url[mode.where].noiseStatistic +
            "/" +
            this.selectedAirport +
            "/" +
            this.selectedYear
        )
        .then(response => {
          let object = new Object()
          for (let j in this.noiseSensorPoint.FeatureCollection.featureMember) {
            
            for (let i in response.data.response.body.items.item) {
              if (
                response.data.response.body.items.item[i].name ===
                this.noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
              ) {
                let array = []
                for (let m in this.monthIndex) {
                  if (
                    response.data.response.body.items.item[i][
                      this.monthIndex[m]
                    ]
                  ) {
                    array.push(
                      response.data.response.body.items.item[i][
                        this.monthIndex[m]
                      ]
                    )
                  } else {
                    array.push("")
                  }
                }
                let name = this.noiseSensorPoint.FeatureCollection.featureMember[j].VIEW_MSRSTN_001.NMS_NM
                object[name] = array
              }
            }
            this.statistics = object
          }
        })
        .catch(err => {
          console.log("Failed to Receive Noise Measures", err)
        })
    },
  },
  mounted() {
    this.selectedYear = new Date().getFullYear()
    for (let i = 0; i < 2; i++) {
      this.yearOption.push(this.selectedYear - i)
    }
  },
  watch: {
    selectedYear: function (newValue, oldValue) {
      this.getStatistic()
    },
    selectedAirport: function (newValue, oldValue) {
      this.getStatistic()
    },
  },
  components: {
    BFormSelect,
  },
}
</script>
<style>
@import "../styles/main.css";
@import "../styles/ag-grid/styles/ag-grid.css";
@import "../styles/ag-grid/styles//ag-theme-dark.css";
</style>
